import FilterToggle from 'views/atoms/FilterToggle/FilterToggle';

export default FilterToggle;
